import { Select } from 'antd'
import styled from 'styled-components'

export const StyledSelect = styled(Select)`
  ${(props) => props.fullwidth === 'true' && 'width: 100%'}
`
